<template>
  <div v-if="invoices.length">
    <div class="invoice-container">
      <div class="invoices-list table">
        <div class="table__header invoice-header">
          <div class="sortable th" @click="$emit('set-sort', 'created')">
            {{ trans('user.invoice.table.id') }}
            <sort
              :enabled="sortField === 'created'"
              :order="sortOrder === 'asc'"
            />
          </div>
          <div class="th">
            {{ trans('user.invoice.table.status') }}
          </div>
          <div class="th">
            {{ trans('user.invoice.table.issue_date') }}
          </div>
          <div class="sortable th" @click="$emit('set-sort', 'term')">
            {{ trans('user.invoice.table.due_date') }}
            <sort
              :enabled="sortField === 'term'"
              :order="sortOrder === 'asc'"
            />
          </div>
          <div class="sortable th" @click="$emit('set-sort', 'total')">
            {{ trans('user.invoice.table.amount') }}
            <sort
              :enabled="sortField === 'total'"
              :order="sortOrder === 'asc'"
            />
          </div>
          <div class="sortable th" @click="$emit('set-sort', 'total')">
            {{ trans('user.invoice.table.amount_vat') }}
            <sort
              :enabled="sortField === 'total'"
              :order="sortOrder === 'asc'"
            />
          </div>
        </div>
        <spinner-container v-if="loading" />
        <Invoice
          v-for="invoice in invoices"
          v-else
          :key="invoice.id"
          :invoice="invoice"
        />
      </div>
    </div>
  </div>
  <div v-else>
    <div class="invoices-list-empty">
      <h3>{{ trans('user.invoice.empty.title') }}</h3>
      <div class="message">
        {{ trans('user.invoice.empty.message') }}
      </div>
    </div>
  </div>
</template>

<script>
import Sort from '@components/Sort.vue';
import SpinnerContainer from '@components/SpinnerContainer.vue';
import translation from '@elements/translation';
import Invoice from './components/Invoice.vue';

export default {
  name: 'InvoicesList',
  components: { Invoice, Sort, SpinnerContainer },
  mixins: [ translation ],
  props: {
    invoices: { type: Array, default: () => [] },
    sortField: { type: String, default: 'created' },
    sortOrder: { type: String, default: 'asc' },
    loading: { type: Boolean, default: false },
  },
};
</script>
